export enum CREATE_ACCOUNT_STEPS {
  email = 'email',
  password = 'password',
  checkEmailCode = 'check_email_code',
  login = 'login',
  ssoOnly = 'sso_only',
}

export const GUEST_AVATAR_CLASS =
  'rounded-full bg-[image:var(--framed-icon-brand-bg)] text-[var(--framed-icon-brand-text)]';

export enum FORM_NAMES {
  email = 'email',
  password = 'password',
  email_code = 'email_code',
}
